import { apiClient } from "lib/apiClient";
import {
  IResearchUnclaimRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const unclaimResearchWorkItem = async (
  workItemId: string,
  request: IResearchUnclaimRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/unclaim`,
    request
  );
  return response.data;
};
